module.exports = flarum.core.compat['components/UserPage'];